import React, { useEffect, useState } from "react";
import "./Commercials.css";

import milaniumImg from "../../assets/Commercial/MILLENIUM WORLD SCHOOL.png";
import sundarImg from "../../assets/Commercial/Copy of Copy of Screenshot 2025-09-23 at 11.16.17 PM-2.jpg";
import sundarImg2 from "../../assets/Commercial/Copy of Copy of Screenshot 2025-09-19 at 11.24.55 PM.jpg";
import sundarImg3 from "../../assets/Commercial/Copy of Copy of Screenshot 2025-09-20 at 2.33.55 PM.jpg";
import sundarImg4 from "../../assets/Commercial/Copy of Copy of Screenshot 2025-09-23 at 10.23.32 PM.jpg";
import sundarImg5 from "../../assets/Commercial/Copy of Copy of Screenshot 2025-09-23 at 11.37.39 PM.jpg";
import sundarImg6 from "../../assets/Commercial/Copy of Copy of Screenshot 2025-09-23 at 7.36.36 PM.jpg";


const commercialGroups = [
  {
    title: "MILLENNIUM WORLD SCHOOL",

    description:
      "Because the smartest children are the ones who never stop asking why.",

    note:
      "The child actor fact-checked me mid-shoot. I should have paid more attention in school.",

    items: [
      {
        title: "MILLENNIUM WORLD SCHOOL",
        category: "COMMERCIAL FILM",
        image: milaniumImg,
      },
    ],
  },

  {
    title: "SUNDER JEWELLERS – WOMEN'S DAY AD",

    description:
      "A tribute to women who wear ambition, passion, and love with equal pride.",

    note:
      "I struggle with work-life balance. They invented it.",

    items: [
      {
        title: "WOMEN'S DAY",
        category: "COMMERCIAL",
        images: [
          sundarImg,
          sundarImg2,
          sundarImg3,
          sundarImg4,
          sundarImg5,
          sundarImg6,
        ],
      },
    ],
  },
];


const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "PODCASTS & INTERVIEWS",
  "EVENTS",
  "SOCIAL AND VERTICAL FILMS",
  "PHOTOGRAPHY CREATIVE",
];


function pad(num) {
  return String(num).padStart(2, "0");
}


function Commercials() {

  const [sundarImageIndex, setSundarImageIndex] = useState(0);


  /* =========================================
     AUTO SLIDER
  ========================================= */

  useEffect(() => {

    const interval = setInterval(() => {

      setSundarImageIndex((prev) =>
        (prev + 1) % 6
      );

    }, 3500);

    return () => clearInterval(interval);

  }, []);


  /* =========================================
     CATEGORY NAVIGATION
  ========================================= */

  const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};


  return (

    <main className="commercial-page">

      <div className="commercial-shell">


        {/* =====================================
            HEADER
        ===================================== */}

        <header className="commercial-main-header">

          <span className="commercial-eyebrow">
            THE CULTURE CAPSULE · VISUAL ARCHIVE
          </span>

          <h1 className="commercial-main-title">
            COMMERCIALS
          </h1>

          <div className="commercial-main-rule">
            <span>
              STORIES MADE TO MOVE
            </span>
          </div>

        </header>



        {/* =====================================
            CONTENT
        ===================================== */}

        <div className="commercial-content">

          {commercialGroups.map((group, groupIndex) => (

            <section
              className="commercial-group"
              key={group.title}
            >


              {/* GROUP HEADER */}

              <div className="commercial-group-heading">

                <div className="commercial-group-number">
                  {pad(groupIndex + 1)}
                </div>

                <div className="commercial-group-title-wrap">

                  <span className="commercial-group-label">
                    COMMERCIAL STORY
                  </span>

                  <h2>
                    {group.title}
                  </h2>

                </div>

                <div className="commercial-group-line" />

              </div>

<div className="commercial-group-copy">

  <p className="commercial-group-description">
    {group.description}
  </p>

  <p className="commercial-group-note">
    {group.note}
  </p>

</div>

              {/* =================================
                  GRID
              ================================= */}

              <div className="commercial-grid">

                {group.items.map((item) => (

                  <article
                    className="commercial-card"
                    key={item.title}
                    tabIndex={0}
                  >


                    {/* IMAGE */}

                    <div className="commercial-image-wrap">

                      {item.images ? (

                        item.images.map((image, index) => (

                          <img
                            key={image}
                            src={image}
                            alt={`${item.title} ${index + 1}`}
                            className={`commercial-card-image ${
                              index === sundarImageIndex
                                ? "active"
                                : ""
                            }`}
                          />

                        ))

                      ) : (

                        <img
                          src={item.image}
                          alt={item.title}
                          className="commercial-card-image active"
                        />

                      )}

                    </div>



                    {/* DARK OVERLAY */}

                    <div className="commercial-card-overlay" />



                    {/* CINEMATIC CORNERS */}

                    <div className="commercial-frame">

                      <span />
                      <span />
                      <span />
                      <span />

                    </div>



                    {/* TOP META */}

                    <div className="commercial-card-top">

                      <span>
                        FILM / {pad(groupIndex + 1)}
                      </span>

                      {item.images && (

                        <span>
                          {pad(sundarImageIndex + 1)}
                          <small>
                            /{pad(item.images.length)}
                          </small>
                        </span>

                      )}

                    </div>



                    {/* PLAY */}

                    <button
                      type="button"
                      className="commercial-play"
                      aria-label={`Play ${item.title}`}
                    >

                      <span />

                    </button>



                    {/* CONTENT */}

                    <div className="commercial-card-info">

                      <span className="commercial-card-kicker">
                        {item.category}
                      </span>

                      <h3>
                        {item.title}
                      </h3>

                    </div>



                    {/* SLIDER PROGRESS */}

                    {item.images && (

                      <div className="commercial-progress">

                        <div className="commercial-progress-track">

                          <span
                            style={{
                              width: `${
                                ((sundarImageIndex + 1) /
                                  item.images.length) *
                                100
                              }%`,
                            }}
                          />

                        </div>

                        <div className="commercial-progress-dots">

                          {item.images.map((_, index) => (

                            <button
                              key={index}
                              className={
                                index === sundarImageIndex
                                  ? "active"
                                  : ""
                              }
                              onClick={() =>
                                setSundarImageIndex(index)
                              }
                              aria-label={`Show image ${
                                index + 1
                              }`}
                            />

                          ))}

                        </div>

                      </div>

                    )}

                  </article>

                ))}

              </div>

            </section>

          ))}

        </div>



        {/* =====================================
            CATEGORY NAV
        ===================================== */}

        <nav className="commercial-category-bar">

          <button
            className="commercial-nav-arrow"
            onClick={() =>
              goToCategory("CAMPAIGNS")
            }
            aria-label="Previous category"
          >
            ←
          </button>


          <div className="commercial-category-list">

            {categories.map((category) => (

              <button
                key={category}
                type="button"
                className={`commercial-category ${
                  category === "COMMERCIALS"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  goToCategory(category)
                }
              >

                {category}

              </button>

            ))}

          </div>


          <button
            className="commercial-nav-arrow"
            onClick={() =>
              goToCategory("BRAND FILMS")
            }
            aria-label="Next category"
          >
            →
          </button>

        </nav>

      </div>

    </main>
  );
}


export default Commercials;